import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import { InstantSearch } from 'react-instantsearch/dom';
import { createConnector } from 'react-instantsearch';
import { connectSearchBox, connectRefinementList } from 'react-instantsearch/connectors';
import MuiAutoComplete from 'material-ui/AutoComplete';

import { algoliaConfig } from '../../../core/algolia'


const VirtualSearchBox = connectSearchBox(() => null);
const connectAutoComplete = createConnector({
  displayName: 'AutoComplete',
  /*
   We retrieve all the values needed:
   - Current query
   - Hits
   To work properly, you need to use Virtual Widgets for the SearchBox and all the
   facets you want the value of.
   */
  getProvidedProps(props, state, search) {
    const hits = search.results ? search.results.hits : [];
    return {
      hits, query: state.query !== undefined ? state.query : '',
    };
  },

  // we update the state of <InstantSearch/> to trigger a new search.
  refine(props, searchState, nextQuery) {
    return {
      ...searchState,
      query: nextQuery,
    };
  },
});


class GroupAutoComplete extends Component {
  constructor(props, context) {
    super(props, context)
    this.handleNewRequest = this.handleNewRequest.bind(this)
  }

  formatHitsForAutoSuggest(props) {
    return props.hits
  }

  handleNewRequest = (value) => {
    const userEmail = value.email
    if (userEmail.length) this.props.loadRecordUpdateState(userEmail)
    this.props.refine('')
  }

  render() {
    const dataSourceConfig = {
      text: 'email',
      value: 'objectID'
    }
    return <MuiAutoComplete
            dataSource={this.formatHitsForAutoSuggest(this.props)}
            dataSourceConfig={dataSourceConfig}
            onNewRequest={this.handleNewRequest}
            openOnFocus={true}
            searchText={this.props.query}
            onUpdateInput={(searchText, dataSource) => {this.props.refine(searchText)}}
          />;
  }

}

const ConnectedAutoComplete = connectAutoComplete(GroupAutoComplete)


class GroupForm extends Component {
  render() {
    return (
      <div>
        <InstantSearch
          appId={algoliaConfig.appID}
          apiKey={algoliaConfig.searchOnlyAPIKey}
          indexName={algoliaConfig.student_index}
          searchParameters={{hitsPerPage: 3}}
        >
          <div>
            <VirtualSearchBox/>
            <ConnectedAutoComplete loadRecordUpdateState={this.props.loadRecordUpdateState}/>
          </div>
        </InstantSearch>
      </div>
    )
  }
}

export default GroupForm


// WEBPACK FOOTER //
// ./src/views/components/group-form/index.js